import { useEffect, useState } from "react";
import axios from 'axios';
import { CircularProgress, Typography, Container, Alert, Box, Paper } from "@mui/material";

const BACKEND_URL = process.env.REACT_APP_BACKEND;

export default function EmailConfirmStep({email_token, onSuccess}) {
    const [confirmStatus, setConfirmStatus] = useState('pending')

    useEffect(() => {
        const checkIfVerified = async () => {
            if (email_token === '') {
                return
            }
            try {
                const requestData = {
                    email_token: email_token,
                }
                const res = await axios.post(`${BACKEND_URL}/api/bookings/checkverification`, requestData);
                if (res.status === 404 || (res.status === 400 && res.data.message === 'Booking expired')) {
                    setConfirmStatus('expired');
                    clearInterval(intervalId);
                } else if (res.status === 200) {
                    if (res.data.verified) {
                        setConfirmStatus('confirmed');
                        console.log(JSON.stringify(res.data));
                        if (onSuccess) onSuccess(res.data.morningLocation, res.data.eveningLocation);
                        clearInterval(intervalId);
                    } else {
                        setConfirmStatus('pending');
                    }
                }
            } catch (err) {
                console.error(err);
                clearInterval(intervalId);
            }
        };

        const intervalId = setInterval(checkIfVerified, 5000);
        checkIfVerified();

        return () => clearInterval(intervalId);

    }, [email_token, confirmStatus]);

    return (
        <Container sx={{ textAlign: "center", mt: 8 }}>
            {confirmStatus === "pending" && (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="25vh"
                    p={2}
                    flexDirection='column'
                >
                    <Paper sx={{ p: 4, maxWidth: 500, textAlign: 'center', marginBottom: '3vh' }} elevation={3}>
                        <Typography variant="h5" gutterBottom>
                            Kinnitusmeil saadetud
                        </Typography>
                        <Typography variant="body1" sx={{ mt: 2 }}>
                            Oleme saatnud Sulle kinnitusmeili. Palun ava oma e-posti postkast ja klõpsa seal olevat linki 10 minuti jooksul, et oma registreerimine kinnitada.
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
                            Kui Sa meili ei näe, kontrolli ka rämpsposti kausta.
                        </Typography>
                    </Paper>
                    <CircularProgress />
                </Box>
            )}
            {confirmStatus === "confirmed" && (
                <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="25vh"
                p={2}
                flexDirection='column'
            >
                <Alert severity="success">
                    <Typography variant="h6">Registreering kinnitatud!</Typography>
                    <Typography>Sinu registreering on edukalt kinnitatud. Koopia sinu registreeringust on saadetud teie e-postile.</Typography>
                </Alert>
            </Box>
            )}

            {confirmStatus === "expired" && (
                <Alert severity="error">
                    <Typography variant="h6">Tekkis viga</Typography>
                    <Typography>Registreeringut ei leitud või see on aegunud.</Typography>
                </Alert>
            )}
        </Container>
    );
}